import script from "./ButtonDisabled.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonDisabled.vue?vue&type=script&setup=true&lang=js"

import "./ButtonDisabled.vue?vue&type=style&index=0&id=aeef1628&lang=css"

const __exports__ = script;

export default __exports__